import { SUBSCRIBE_TYPE, UNSUBSCRIBE_TYPE } from '../actionTypes.js';
export function createSubscription(endpoint, {
  args
}) {
  return {
    type: SUBSCRIBE_TYPE,
    endpoint,
    meta: {
      args,
      key: endpoint.key(...args),
      fetch: () => endpoint(...args),
      schema: endpoint.schema,
      options: endpoint
    }
  };
}
/** Future action shape
{
  type: SUBSCRIBE_TYPE,
  endpoint,
  meta: {
    args,
  },
} */

export function createUnsubscription(endpoint, {
  args
}) {
  return {
    type: UNSUBSCRIBE_TYPE,
    endpoint,
    meta: {
      args,
      key: endpoint.key(...args),
      options: endpoint
    }
  };
}
/** Future action shape
{
  type: UNSUBSCRIBE_TYPE,
  endpoint,
  meta: {
    args,
  },
} */
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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